import { render, staticRenderFns } from "./ResponsibleUser.vue?vue&type=template&id=74efb8e7&scoped=true&"
import script from "./ResponsibleUser.vue?vue&type=script&lang=js&"
export * from "./ResponsibleUser.vue?vue&type=script&lang=js&"
import style0 from "./ResponsibleUser.vue?vue&type=style&index=0&id=74efb8e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74efb8e7",
  null
  
)

export default component.exports